import React,{useEffect, useState} from 'react'
import axios from './axios';
import './Row.css'
import Youtube from "react-youtube";
import movieTrailer from 'movie-trailer';
const base_url="https://image.tmdb.org/t/p/original/";

const Row = ({title,fetchUrl,isLargeRow}) => {
const [movies,setMovies]=useState([]);
const [trailerUrl,setTrailerUrl]=useState("");

useEffect(() => {
    async function fetchData(){
const request= await axios.get(fetchUrl);
setMovies(request.data.results);
return request;
    }
    fetchData();

},[fetchUrl]);
const opts={
    height:"390",width:"100%",playerVars:{autoplay:1,},
};
const handleClick= (movie) => {
   if(trailerUrl){
    setTrailerUrl('');
   } else {
    const params = new URLSearchParams(new URL(window.location.href).search);
    movieTrailer(movie.title || movie.name, { lang: params.get('language') })
      .then(url => {
        const urlParams = new URLSearchParams(new URL(url).search);
        setTrailerUrl(urlParams.get('v'));
      })
      .catch(error => console.error(error));
   }
}

  return (
    <div className="row">
<h2>{title}</h2>
<div className={`row_posters ${isLargeRow && "row_posterLarge"}`}>
    
    {movies.map(movie => (
        <img onClick={()=> handleClick(movie)} key={movie.id} className="row_poster"src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} alt={movie.name}/>
    ))}

</div>
{trailerUrl && <Youtube videoId={trailerUrl} opts={opts}/>}
    </div>
  )
}

export default Row